const supplierQuotation = {
    status: '상태',
    productCode: "상품 코드",
    productName: "상품명",
    productModel: "상품 모델",
    productCount: "상품 수량",
    mrd: '예상 배송 시간',
    deadline: "최후 제출 시간",
    mpq: "계약 최소 포장",
    curMpq: "단일 최소 포장",
    days: "계약 공급 주기",
    curDays: "단일 공급 주기",
    price: "계약가격",
    curPrice: "단일 견적",
    curTotalPrice: "단일 총 가격",
    submitTimer: "제출 카운트다운",
    operation: '작업',
    handlePrice: "견적",
    priceInfo: '견적 정보',
    rejected: "거부됨",
    confirmQuotate: '견적을 확인하시겠습니까?',
    confirmQuotateTip: '이것은 이 상품에 대한 견적을 제출할 것입니다',
};

export default supplierQuotation;